import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { isCarinaGlyph, remapIconSize } from "../../Icon/types";
export var NavigationIcon = function(param) {
    var IconGlyph = param.icon;
    return _jsx("span", {
        children: isCarinaGlyph(IconGlyph) ? _jsx(IconGlyph, {
            size: remapIconSize('m')
        }) : _jsx(IconGlyph, {
            size: "m"
        })
    });
};
export default NavigationIcon;
